import { useTranslations } from 'next-intl';
import type { LabeledRankingResult } from './types';

interface ScreenReaderTableProps {
  labeledResults: LabeledRankingResult[];
  shouldHideResults: boolean;
}

export const ScreenReaderTable = ({
  labeledResults,
  shouldHideResults,
}: ScreenReaderTableProps) => {
  const translate = useTranslations('presenting.screenreader_table');

  if (shouldHideResults) {
    return <span>{translate('results_are_hidden_message')}</span>;
  }

  const sortedResults = [...labeledResults].sort((a, b) => b.score - a.score);

  return (
    <table>
      <caption>{translate('results_table_caption')}</caption>
      <thead>
        <tr>
          <th scope="col">{translate('option_column_title')}</th>
          <th scope="col">{translate('position_column_title')}</th>
        </tr>
      </thead>
      <tbody>
        {sortedResults.map((result, index) => {
          return (
            <tr key={result.id}>
              <th scope="row">{result.label}</th>
              <td>{index + 1}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
